import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import withHeaderContentAlignmentStyles from '../hoc/withHeaderContentAlignmentStyles';
import { calculateLogoSize } from '../utils/logoSizeUtils';
import {
  headerLogoSizePresetPropTypes,
  sizePropTypes,
} from '../../../config/sectionHeader/sectionHeaderPropTypes';
import toPx from '../../../utils/toPx';
import { minSize } from '../configs/headerLogoImageSizesConfig';

import styles from './HeaderLogo.scss';

class HeaderLogo extends Component {
  static propTypes = {
    logoImageUrl: PropTypes.string.isRequired,
    logoImageLinkUrl: PropTypes.string,
    headerSize: sizePropTypes,
    sizePreset: headerLogoSizePresetPropTypes,
    size: sizePropTypes,
    className: PropTypes.string,
    restrictionEnabled: PropTypes.bool,
  };

  static defaultProps = {
    logoImageLinkUrl: '',
    className: '',
    size: null,
    restrictionEnabled: true,
  };

  state = {
    imageSize: minSize,
    loaded: false,
  };

  onClickHandler = () => {
    const { logoImageLinkUrl } = this.props;
    !!logoImageLinkUrl && window.open(logoImageLinkUrl, '_blank');
  };

  onImageLoadHandler = ({ target: { height, width } }) => {
    const imageSize = { width, height };
    this.setState({ loaded: true, imageSize });
  };

  getLogoSize = ({
    size = this.props.size,
    sizePreset = this.props.sizePreset,
    headerSize = this.props.headerSize,
    imageSize = this.state.imageSize,
    restrictionEnabled = this.props.restrictionEnabled,
  } = {}) =>
    calculateLogoSize({
      size,
      sizePreset,
      headerSize,
      imageSize,
      restrictionEnabled,
    });

  render() {
    const { className, logoImageUrl, logoImageLinkUrl } = this.props;
    const { loaded } = this.state;
    const { width, height } = this.getLogoSize();

    return (
      <div
        className={cx(styles.container, className, {
          [styles.hidden]: !loaded,
        })}
      >
        <div style={{ width: toPx(width), height: toPx(height) }}>
          <img
            src={logoImageUrl}
            className={cx(styles.image, {
              [styles.linkedImage]: logoImageLinkUrl,
            })}
            onClick={this.onClickHandler}
            onLoad={this.onImageLoadHandler}
          />
        </div>
      </div>
    );
  }
}

export default withHeaderContentAlignmentStyles(HeaderLogo);
